module.exports = __webpack_public_path__ + "static/img/watch.85214744.png";